import { useEffect, useRef } from "react";
import { useDrokAccess } from "./use-drok-access";

/**
 * Whether a user with no agents is sent to onboarding to create one. Employees stay in the app and
 * see the empty state; while access is loading the answer is yes, and the onboarding gate then
 * sends an employee back. Read through a ref so effects that navigate need no new dependency.
 */
export function useCreatesFirstBot(): { current: boolean } {
  const access = useDrokAccess();
  const ref = useRef(access !== "employee");
  useEffect(() => {
    ref.current = access !== "employee";
  }, [access]);
  return ref;
}
